import {Injectable} from "@angular/core";
import {EnergyLetter, InfosConsom, NrjAndGesConsom} from "../Models/EnergyClass";

@Injectable({
	providedIn: 'root'
})
export class EnergieHelper {
	mapInfosConsom(src: any): InfosConsom {
		return {
			energy_dpe_class: src?.energy_dpe_class as EnergyLetter,
			carbon_dpe_class: src?.carbon_dpe_class as EnergyLetter,
			primary_energy_consumption: Number(src?.primary_energy_consumption ?? 0),
			carbon_consumption: Number(src?.carbon_consumption ?? 0),
			energy_dpe_color: src?.energy_dpe_color,
			carbon_dpe_color: src?.carbon_dpe_color,
		};
	}

	mapToNrjConsom(src: any): NrjAndGesConsom {
		return {
			before_renovation: this.mapInfosConsom(src?.before_renovation ?? {}),
			after_renovation: this.mapInfosConsom(src?.after_renovation ?? {}),
			energy_thresholds: src?.energy_thresholds ?? {},
			ges_thresholds: src?.ges_thresholds ?? {},
			numero_ademe: src?.numero_ademe,
		};
	}
}
